'use client'

import { createContext, useContext, useState } from 'react'

const TradeSlideContext = createContext(null)

export function TradeSlideProvider({ children }) {
    const [currentSlide, setCurrentSlide] = useState(null)

    return (
        <TradeSlideContext.Provider value={{ currentSlide, setCurrentSlide }}>
            {children}
        </TradeSlideContext.Provider>
    )
}

export function useTradeSlide() {
    return useContext(TradeSlideContext)
}
